namespace GeniuzPOS.SalePromoCamp {
    export enum PromoType {
        FixedPrice = 1,
        PercentDiscount = 2
    }
    Serenity.Decorators.registerEnumType(PromoType, 'GeniuzPOS.SalePromoCamp.PromoType', 'SalePromoCamp.PromoType');
}
